import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { Wissenstest } from './app.component';
import { HomePage } from '../pages/home/home';
import { Settings } from '../pages/settings/settings';
import { About } from '../pages/about/about';
import { StufenSelector } from '../pages/stufe/stufe';
import { ThemenSelector } from '../pages/thema/thema';
import { Question } from '../pages/question/question';
import { Service } from './service';
import { Storage } from '@ionic/storage';
import { QrCode } from '../pages/qrcode/qrcode';
import { QRCodeModule } from 'angular2-qrcode';
import { QRCodeComponent } from 'ng2-qrcode';

@NgModule({
  declarations: [
    Wissenstest,
    HomePage,
    Settings,
    About,
    StufenSelector,
    ThemenSelector,
    Question,
    QrCode
  ],
  imports: [
    IonicModule.forRoot(Wissenstest),
    QRCodeModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    Wissenstest,
    HomePage,
    Settings,
    About,
    StufenSelector,
    ThemenSelector,
    Question,
    QrCode
  ],
  providers: [
    Storage,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts